import React from 'react';
import Title from '../../components/Title';
import { PrimaryButton } from '@fluentui/react';
import { gql, useMutation } from '@apollo/client';

const LOGOUT_MUTATION = gql`mutation { logout { Completed Error } }`;

const Configuracion = () => {
	const [logout] = useMutation(LOGOUT_MUTATION);

	return(
		<section>
			<Title title={"Configuración"}/>
			<PrimaryButton
				iconProps={{ iconName: 'SignOut' }}
				text="Cerrar sesión"
				onClick={() => { logout().finally(()=>{ window.localStorage.removeItem('auth-token'); window.location.reload(); }) }}
				allowDisabledFocus
			/>
		</section>
	)
}

export default Configuracion;